angular.module('app').component('xmlView', {
    template: function () {
        let template = `
<style>
.CodeMirror {
  border: 1px solid #eee;
  height: auto;
  overflow-y: hidden;
  overflow-x: hidden;
}
.CodeMirror-scroll {
  overflow-y: hidden;
  overflow-x: hidden;
}
</style>
<textarea class="xml-view" ui-codemirror="$ctrl.options" ui-refresh="$ctrl.model" ng-model="$ctrl.model"
</textarea>`;
        return template;
    },
    bindings: {
        model: '=',
        readOnly: '<',
        folding: '<'
    },
    controller: function () {
        this.$onInit = function () {
            if (this.model === null) {
                this.model = 'No content to display.';
            }
            // NOTE: Do not try to render files larger than 100KB instead display a message
            let maxSize = 151 * 1014;
            if (this.model !== null && this.model.length > maxSize) {
                this.model = `
This content is over ${Math.round(maxSize / 1024)} KB which is too big to render internally. 
Please download and render externally.`;
            }
            // Set up the options for view only
            // NOTE: Styles are overridden in site.css
            this.options = {
                readOnly: this.readOnly || false,
                mode: 'xml',
                theme: 'solarized',
                indentUnit: 4,
                foldGutter: this.folding || false,
                gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
                autoRefresh: true,
                // indicatorOpen: '-',   // Handled by .CodeMirror-foldgutter-open:before class
                // indicatorFolded: '+', // Handled by .CodeMirror-foldgutter-folded:before class
                incrementalLoading: true,
                lineNumbers: true, //viewportMargin: 'Infinity', scrollbarStyle: 'null', These attributes are not working for codemirror
                lineWrapping: true
            };
        };
        this.$onChanges = function (changes) {
            if (this.options != null && this.options.readOnly != null) {
                this.options.readOnly = changes.readOnly.currentValue;
            }
        };
    }
});
